export default __webpack_public_path__ + "static/media/image-frame-2.1e3db2f6.jpg";